jQuery(document).ready(function ($) {
  // Check if the password field exists
  setTimeout(function () {
    var $submitButton = $(
      '#signup_submit, #resetpassform input[type="submit"], #settings-form input[type="submit"]',
    );
    var $passwordField = $("#pass1, #signup_password");

    if (
      wp &&
      wp.passwordStrength &&
      typeof wp.passwordStrength.userInputBlacklist === "function"
    ) {
      wp.passwordStrength.userInputBlacklist =
        wp.passwordStrength.userInputDisallowedList;
    }
    if ($(".pw-weak")) {
      $(".pw-weak").remove();
    }
    function checkPasswordStrength() {
      if ($passwordField.length === 0) return;
      var password = $passwordField.val();
      var strength;

      if (typeof password === "string" && password.trim().length > 0) {
        strength = wp.passwordStrength.meter(password, [], password);
      } else {
        strength = 0;
      }
      // If the password is strong enough, enable the submit button
      if (strength < 3) {
        $submitButton.prop("disabled", true);
        $submitButton.css("pointer-events", "none");
      } else {
        $submitButton.prop("disabled", false);
        $submitButton.css("pointer-events", "auto");
      }
    }

    if ($passwordField.length > 0) {
      $passwordField.on("input", checkPasswordStrength);
      checkPasswordStrength();
    }
  }, 100);
});
